import { useCallback } from "react";
import { Button, Stack, Text } from "@mantine/core";

interface ReportPhotoErrorProps {
  imageId: string;
  onRetry?: (imageId: string) => void;
}

export function ReportPhotoError(props: ReportPhotoErrorProps) {
  const { imageId, onRetry } = props;
  const handleRetry = useCallback(() => onRetry?.(imageId), [imageId, onRetry]);
  return (
    <Stack align="center" gap="xs" py="lg">
      <Text c="red" size="sm">
        This report photo could not be loaded.
      </Text>
      {onRetry && (
        <Button variant="light" onClick={handleRetry} mih={44}>
          Retry photo
        </Button>
      )}
    </Stack>
  );
}
